import React from 'react'

type Props = {
    className?: string
}


export default function ModalMoveTo_NoResultsFound(props: Props) {

// .no-results {
//         color: $palette-font-no-accent;
//         text-align: center;
//         margin: 40px 0 0 -20px;
//         line-height: 40px;
//     }


    return (
        <div className="ui5-txt-no-accent-default flex-row-center-center w-100-percent m-t-40">
            No folders/projects found
        </div>
    )

}
